import React from 'react';
import { array, bool } from 'prop-types';
import CollectionListItem from './CollectionListItem';
import '../styles/CollectionList.css';

export default function CollectionList({ collections = [], showImage }) {
    return (<section
        className={'collection-list--container'}>
        <ul
            className={'collection-list--inner'}>
            {collections.map((collection) => (
                <CollectionListItem
                    key={collection.id}
                    title={collection.title}
                    imageUrl={collection.imageUrl}
                    handle={collection.handle}
                    showImage={showImage} />
            ))}
        </ul>
    </section>);
}

CollectionList.propTypes = {
    collections: array,
    showImage: bool,
};

CollectionList.defaultProps = {
    collections: [],
    showImage: true,
};